import React, { Component } from 'react';
import { Upload, Modal, Button, Input, Icon } from 'antd';
import styles from './Popup.module.css';

const { Dragger } = Upload;

class ImportPopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      file: null,
      fileObj: null,
      wsName: '',
    };
  }

  setFile = (file) => {
    let tempFile = {};
    const fileObj = new FormData();
    fileObj.append('file', file);
    tempFile = {
      src: URL.createObjectURL(file),
      name: file.name.split('.')[0],
    };
    this.setState({
      file: tempFile,
      fileObj,
    });
  };

  removeFile = () => {
    this.setState({
      file: null,
      fileObj: null,
    });
  };

  valueChange = (e) => {
    this.setState({
      file: {
        ...this.state.file,
        name: e.target.value,
      },
    });
  };

  importFile = () => {
    const { fileObj, file } = this.state;
    fileObj &&
      this.props.fileImport({
        fileObj,
        name: file.name,
      });
  };

  render() {
    const { closeImport, visible, title } = this.props;
    const { file, fileObj } = this.state;
    return (
      <Modal
        centered
        className={styles.importPopup}
        title={title}
        visible={visible}
        footer={
          <Button
            onClick={fileObj && this.importFile}
            className={styles.imageBtn}
          >
            Import
          </Button>
        }
        onCancel={closeImport}
      >
        {file ? (
          <div
            style={{
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
              paddingTop: '10px',
            }}
          >
            <div className={styles.importedFileContainer}>
              <Icon
                type="folder"
                style={{
                  fontSize: '100px',
                  color: '#08c',
                }}
                theme="filled"
              />
              <Icon
                type="close-circle"
                onClick={this.removeFile}
                style={{
                  position: 'absolute',
                  top: 5,
                  right: 5,
                  fontSize: '15px',
                  color: 'red',
                }}
                theme="outlined"
              />
            </div>
          </div>
        ) : (
          <Dragger
            className={styles.importWorkspace}
            // accept=".zip"
            beforeUpload={(file) => {
              this.setFile(file);
              return false;
            }}
          >
            <span className="flaticon-photo" />
            <span className={styles.dragText}>
              Drag & drop to import
              <br />
              or
            </span>
            <span
              style={{
                color: '#005AB4',
                fontWeight: 'bold',
              }}
              className={styles.dragText}
            >
              Select Model
            </span>
          </Dragger>
        )}
        <label className={styles.namelabel}>Model name</label>
        <Input
          value={file && file.name}
          className={styles.inputStyles}
          onChange={(e) => this.valueChange(e)}
          onPressEnter={this.importFile}
        />
      </Modal>
    );
  }
}

export default ImportPopup;
